<div class="wishlist-container">
  <!-- Header -->
  <div class="wishlist-header">
    <button type="button" class="back-button" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </button>
    <h1 class="wishlist-title">My Wishlist</h1>
    @if (wishListItems().length > 0) {
      <button type="button" class="clear-button" (click)="clearWishList()">
        <i class="pi pi-trash"></i>
        <span>Clear All</span>
      </button>
    }
  </div>

  <!-- Loading State -->
  @if (loading()) {
    <div class="loading-container">
      <p-progressSpinner></p-progressSpinner>
      <p class="loading-text">Loading wishlist...</p>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="error-container">
      <div class="error-icon">⚠️</div>
      <p class="error-message">{{ error() }}</p>
      <p-button label="Retry" (onClick)="loadWishList()" [raised]="true" severity="primary"></p-button>
    </div>
  }

  <!-- Wishlist Items -->
  @if (!loading() && !error() && wishListItems().length > 0) {
    <div class="wishlist-grid">
      @for (item of wishListItems(); track item.id) {
        <div class="wishlist-item-card">
          <div class="item-image-container" (click)="goToProduct(item)">
            <img 
              [src]="getProductImage(item)" 
              [alt]="item.productName"
              class="item-image"
              (error)="$any($event.target).src='/assets/placeholder-product.png'"
            />
            @if (item.discountPercentage && item.discountPercentage > 0) {
              <div class="discount-badge">
                -{{ item.discountPercentage }}%
              </div>
            }
            @if (!item.isInStock) {
              <div class="out-of-stock-badge">
                Out of Stock
              </div>
            }
          </div>
          
          <div class="item-info">
            <h3 class="item-name" (click)="goToProduct(item)">{{ item.productName }}</h3>
            @if (item.brandName) {
              <p class="item-brand">{{ item.brandName }}</p>
            }
            @if (item.categoryName) {
              <p class="item-category">{{ item.categoryName }}</p>
            }
            
            <div class="item-price">
              <span class="current-price">{{ formatPrice(item.productPrice) }}</span>
              @if (item.compareAtPrice && item.compareAtPrice > item.productPrice) {
                <span class="old-price">{{ formatPrice(item.compareAtPrice) }}</span>
              }
            </div>

            @if (item.notes) {
              <div class="item-notes">
                <i class="pi pi-note"></i>
                <span>{{ item.notes }}</span>
              </div>
            }

            <div class="item-actions">
              <p-button 
                label="Remove" 
                icon="pi pi-trash" 
                severity="danger" 
                [text]="true"
                (onClick)="removeFromWishList(item)"
              ></p-button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Empty State -->
  @if (!loading() && !error() && wishListItems().length === 0) {
    <div class="empty-container">
      <div class="empty-icon">❤️</div>
      <h2>Your wishlist is empty</h2>
      <p>Start adding products you love to your wishlist!</p>
      <p-button 
        label="Browse Products" 
        (onClick)="goBack()" 
        [raised]="true"
        severity="primary"
      ></p-button>
    </div>
  }
</div>

<p-toast position="bottom-right"></p-toast>
